// Server fn: hämta auto-matchade relaterade kunskapsartiklar för en tjänstesida.
// Anropas från RelatedKnowledgeAuto via useQuery (SSR-vänligt).
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";
import { scoreArticles } from "@/lib/seo/article-topics";

const Input = z.object({
  topics: z.array(z.string().min(1).max(64)).min(1).max(20),
  exclude: z.array(z.string().min(1).max(200)).max(20).optional(),
  limit: z.number().int().min(1).max(6).optional(),
});

export const getRelatedKnowledge = createServerFn({ method: "GET" })
  .inputValidator((input) => Input.parse(input))
  .handler(async ({ data }) => {
    const limit = data.limit ?? 3;
    const { data: posts, error } = await supabaseAdmin
      .from("blog_posts")
      .select("slug, title, excerpt, category, published_at")
      .eq("status", "published")
      .order("published_at", { ascending: false });
    if (error) throw new Error(error.message);

    const scored = scoreArticles(posts ?? [], data.topics, data.exclude ?? []);

    // Fallback: om inget matchar (för smalt topic-set) → nyaste artiklarna.
    const pick = scored.length
      ? scored.slice(0, limit).map((s) => s.item)
      : (posts ?? []).slice(0, limit);

    return {
      items: pick.map((p) => ({
        slug: p.slug,
        title: p.title,
        excerpt: p.excerpt,
      })),
    };
  });
